import { cn } from '@utils/cn';

type SiteLogoProps = {
  className?: string;
};

/**
 * Render the cached logo SVG as a mask so it can keep following `currentColor`
 * without repeating the full path data in the header and footer HTML.
 */
export function SiteLogo({ className }: SiteLogoProps) {
  return (
    <span
      aria-hidden="true"
      className={cn('block aspect-[884/482] w-full shrink-0 bg-current', className)}
      style={{
        WebkitMaskImage: "url('/vectors/metliefde-logo.svg')",
        WebkitMaskPosition: 'center',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskImage: "url('/vectors/metliefde-logo.svg')",
        maskPosition: 'center',
        maskRepeat: 'no-repeat',
        maskSize: 'contain',
      }}
    />
  );
}
